<aside
  class="fixed left-0 top-0 z-10 w-96 flex h-screen flex-col overflow-y-auto border-r border-gray-200 bg-white dark:border-gray-700 dark:bg-gray-900"
>
  <!-- Logo -->
  <div class="flex h-18 items-center justify-start border-gray-200 px-5 dark:border-gray-700">
    <a routerLink="/" class="flex items-center gap-2">
      <div class="flex items-center justify-center rounded-lg">
        <img
          ngSrc="/image/logo2.png"
          alt="Portale Logo"
          width="608"
          height="596"
          style="width: 40px; height: auto"
          priority
        />
      </div>

      <span class="text-md font-stretch-75% font-semibold text-gray-900 dark:text-white"
        >Responsabile Della Conservazione</span
      >
    </a>
  </div>

  <!-- Navigation -->
  <nav class="flex-1 overflow-y-auto px-1 py-4">
    @if (isAdmin() && status(); as currentStatus) {
      <div
        class="mb-3 rounded-xl bg-slate-50/50 px-2 py-1 dark:bg-slate-800/40 border border-slate-100 dark:border-slate-800"
      >
        <div class="flex items-center justify-between gap-x-2">
          <div class="flex flex-col min-w-0">
            <h3
              class="truncate text-[13px] font-bold text-slate-900 dark:text-white tracking-tight"
              [title]="currentStatus.organization_name"
            >
              {{ currentStatus.organization_name }}
            </h3>
            <div class="flex items-center gap-1">
              <span class="text-[10px] font-bold text-slate-400 uppercase tracking-tighter"
                >P.IVA</span
              >
              <span class="text-[11px] font-medium text-slate-600 dark:text-slate-400">
                {{ currentStatus.organization_PIVA }}
              </span>
            </div>
          </div>
          @if (currentStatus.version) {
            <span
              class="inline-flex items-center rounded-md px-2 py-1 text-[10px] font-medium ring-1 ring-inset whitespace-nowrap bg-slate-100 text-slate-700 ring-slate-600/20 dark:bg-slate-800 dark:text-slate-300 dark:ring-slate-500/20"
            >
              v{{ currentStatus.version }}
            </span>
          }
        </div>
      </div>
    }

    <ul class="space-y-1">
      @for (item of menuItems(); track item.id) {
        <li>
          @if (item.children) {
            <!-- Expandable Menu Item -->
            <button
              type="button"
              (click)="toggleMenu(item.id)"
              class="group flex w-full items-center cursor-pointer justify-between rounded-lg px-3 py-2.5 text-sm font-medium text-gray-700 transition-colors dark:text-gray-300"
              [class.bg-slate-50]="isExpanded(item.id)"
              [class.dark:bg-slate-800/60]="isExpanded(item.id)"
              [class.hover:bg-gray-100]="!isExpanded(item.id)"
              [class.dark:hover:bg-gray-800]="!isExpanded(item.id)"
              [attr.aria-expanded]="isExpanded(item.id)"
            >
              <div class="flex items-center gap-3">
                <!-- Icons -->
                @switch (item.icon) {
                  @case ('user-circle') {
                    <svg class="h-5 w-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        d="M5.121 17.804A13.937 13.937 0 0112 16c2.5 0 4.847.655 6.879 1.804M15 10a3 3 0 11-6 0 3 3 0 016 0zm6 2a9 9 0 11-18 0 9 9 0 0118 0z"
                      />
                    </svg>
                  }
                  @case ('document-text') {
                    <svg class="h-5 w-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        d="M7 21h10a2 2 0 002-2V9.414a1 1 0 00-.293-.707l-5.414-5.414A1 1 0 0012.586 3H7a2 2 0 00-2 2v14a2 2 0 002 2z"
                      />
                    </svg>
                  }
                }

                <span>{{ item.label }}</span>
              </div>
              <div class="flex items-center gap-2">
                <svg
                  class="h-4 w-4 transition-transform duration-200"
                  [class.rotate-180]="isExpanded(item.id)"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M19 9l-7 7-7-7"
                  />
                </svg>
              </div>
            </button>

            <!-- Submenu -->
            @if (isExpanded(item.id)) {
              <ul class="mt-1 space-y-1 pl-5">
                @for (child of item.children; track child.id) {
                  <li>
                    <a
                      [routerLink]="child.route"
                      [queryParams]="child.queryParams"
                      routerLinkActive
                      #rla="routerLinkActive"
                      class="block rounded-lg px-2 py-2 text-sm transition-colors"
                      [class.bg-blue-50]="rla.isActive"
                      [class.text-blue-600]="rla.isActive"
                      [class.dark:bg-blue-900/20]="rla.isActive"
                      [class.dark:text-blue-400]="rla.isActive"
                      [class.text-gray-600]="!rla.isActive"
                      [class.dark:text-gray-400]="!rla.isActive"
                      [class.hover:bg-gray-100]="!rla.isActive"
                      [class.hover:text-gray-900]="!rla.isActive"
                      [class.dark:hover:bg-gray-800]="!rla.isActive"
                      [class.dark:hover:text-white]="!rla.isActive"
                    >
                      <div class="flex items-center justify-between">
                        <span>{{ child.label }} </span>
                        <div class="flex items-center gap-1 min-h-5.5">
                          @if (rla.isActive && getChildBadge(child.id, true); as info) {
                            <span [class]="statusPillClass(info)">{{ info.text }}</span>
                          } @else if (getSubsectionBadge(child.id); as sub) {
                            <span
                              class="subsection-count relative cursor-default inline-flex items-center justify-center rounded-full bg-gray-200 dark:bg-gray-700 text-[9px] font-bold text-gray-600 dark:text-gray-300 min-w-4.5 h-4.5 px-1"
                            >
                              {{ sub.count }}
                              <span class="subsection-tooltip">
                                @for (d of sub.details; track d.name) {
                                  <span class="subsection-tooltip-row">
                                    <span class="subsection-tooltip-name">{{ d.name }}</span>
                                    <span [class]="tooltipStatusPillClass(d.statusKey)">{{
                                      d.status
                                    }}</span>
                                  </span>
                                }
                              </span>
                            </span>
                            <span [class]="statusPillClass(sub)">{{ sub.text }}</span>
                          } @else if (!rla.isActive && getChildBadge(child.id, false); as info) {
                            <span [class]="statusPillClass(info)">{{ info.text }}</span>
                          }
                        </div>
                      </div>
                    </a>
                  </li>
                }
              </ul>
            }
          } @else {
            <!-- Regular Menu Item -->
            <a
              [routerLink]="item.route"
              [queryParams]="item.queryParams"
              routerLinkActive
              #rla="routerLinkActive"
              class="group flex items-center justify-between rounded-lg px-3 py-2.5 text-sm font-medium transition-colors"
              [class.bg-blue-50]="rla.isActive"
              [class.text-blue-600]="rla.isActive"
              [class.dark:bg-blue-900/20]="rla.isActive"
              [class.dark:text-blue-400]="rla.isActive"
              [class.text-gray-700]="!rla.isActive"
              [class.dark:text-gray-300]="!rla.isActive"
              [class.hover:bg-gray-100]="!rla.isActive"
              [class.dark:hover:bg-gray-800]="!rla.isActive"
            >
              <div class="flex items-center gap-3">
                @switch (item.icon) {
                  @case ('archive') {
                    <svg class="h-5 w-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        d="M5 8h14M5 8a2 2 0 110-4h14a2 2 0 110 4M5 8v10a2 2 0 002 2h10a2 2 0 002-2V8m-9 4h4"
                      />
                    </svg>
                  }
                  @case ('clipboard-list') {
                    <svg class="h-5 w-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-6 9l2 2 4-4"
                      />
                    </svg>
                  }
                  @case ('briefcase') {
                    <svg class="h-5 w-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        d="M21 13.255A23.931 23.931 0 0112 15c-3.183 0-6.22-.62-9-1.745M16 6V4a2 2 0 00-2-2h-4a2 2 0 00-2 2v2m4 6h.01M5 20h14a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
                      />
                    </svg>
                  }
                  @case ('chart-line') {
                    <svg class="h-5 w-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        d="M7 12l3-3 3 3 4-4M8 21l4-4 4 4M3 4h18M4 4h16v12a1 1 0 01-1 1H5a1 1 0 01-1-1V4z"
                      />
                    </svg>
                  }
                }
                <span>{{ item.label }}</span>
              </div>
              @if (getBadgeInfo(item.id); as info) {
                <span [class]="statusPillClass(info, true)">{{ info.text }}</span>
              }
            </a>
          }
        </li>
      }
    </ul>
  </nav>
</aside>
